export type RecipeIcon = {
  categoryCode: string;
  icon: string;
};

// prettier-ignore
const recipes: RecipeIcon[] = [
  // ORIGINAL
  { categoryCode: 'capsule-cupSize-icedRecipe', icon: '24/recipe/iced-coffee'},
  { categoryCode: 'capsule-cupSize-Cappuccino-And-Latte-Macchiato', icon: '24/recipe/cappuccino-ol'},
  { categoryCode: 'capsule-cupSize-Cortado-Cappuccino', icon: '24/recipe/cortado-ol'},

  // VERTUO
  { categoryCode: 'capsule-cupSize-icedRecipe-vertuo', icon: '24/recipe/iced-vl', },
  { categoryCode: 'capsule-cupSize-Reverso', icon: '24/recipe/reverso-vl', },
  { categoryCode: 'capsule-cupSize-Double-Cappuccino', icon: '24/recipe/double-cappuccino-vl', },

  // OTHERS
  { categoryCode: 'recipe-biscuit', icon: '24/coffeenote/biscuit', },
  { categoryCode: 'recipe-biscuity	', icon: '24/coffeenote/biscuit', },
  { categoryCode: 'recipe-capsule-aromatic-ginseng', icon: '24/coffeenote/ginseng', },
  { categoryCode: 'recipe-capsule-aromatic-pistachio', icon: '24/coffeenote/pistachio', },
  { categoryCode: 'recipe-capsule-aromatic-whiskey-flavor', icon: '24/coffeenote/alcohol', },
  { categoryCode: 'recipe-capsule-aromatic-whisky-flavour', icon: '24/coffeenote/alcohol', },
  { categoryCode: 'recipe-coconut', icon: '24/coffeenote/coconut', },
  { categoryCode: 'recipe-almond', icon: '24/coffeenote/almonds', },
  { categoryCode: 'recipe-almonds', icon: '24/coffeenote/almonds', },
  { categoryCode: 'recipe-capsule-aromatic', icon: '24/coffeenote/flowery', },
  { categoryCode: 'recipe-caramel', icon: '24/coffeenote/caramel', },
  { categoryCode: 'recipe-caramellynotes-b2b', icon: '24/coffeenote/caramel', },
  { categoryCode: 'recipe-chocolate', icon: '24/coffeenote/chocolate', },
  { categoryCode: 'recipe-fruity', icon: '24/coffeenote/fruity', },
  { categoryCode: 'recipe-fruityWiney', icon: '24/coffeenote/fruity', },
  { categoryCode: 'recipe-hazelnut', icon: '24/coffeenote/hazelnut', },
  { categoryCode: 'recipe-hintOfFruity', icon: '24/coffeenote/fruity', },
  { categoryCode: 'recipe-malted', icon: '24/coffeenote/malted', },
  { categoryCode: 'recipe-maltedCereal', icon: '24/coffeenote/malted', },
  { categoryCode: 'recipe-nut', icon: '24/coffeenote/hazelnut', },
  { categoryCode: 'recipe-nutty', icon: '24/coffeenote/hazelnut', },
  { categoryCode: 'recipe-peppermint', icon: '24/coffeenote/peppermint', },
  { categoryCode: 'recipe-oak-wood', icon: '24/coffeenote/oak-wood', },
  { categoryCode: 'recipe-peppery', icon: '24/coffeenote/spicy', },
  { categoryCode: 'recipe-refreshing-mint', icon: '24/coffeenote/peppermint', },
  { categoryCode: 'recipe-rich-b2b', icon: '24/coffeenote/intense', },
  { categoryCode: 'recipe-roasted', icon: '24/coffeenote/roasted', },
  { categoryCode: 'recipe-roastedCereal', icon: '24/coffeenote/roasted', },
  { categoryCode: 'recipe-smooth', icon: '24/coffeenote/balance', },
  { categoryCode: 'recipe-smooth-b2b', icon: '24/coffeenote/balance', },
  { categoryCode: 'recipe-spicy', icon: '24/coffeenote/spicy', },
  { categoryCode: 'recipe-sugar', icon: '24/coffeenote/sugar', },
  { categoryCode: 'recipe-sweet', icon: '24/coffeenote/sugar', },
  { categoryCode: 'recipe-sweetnotes-b2b', icon: '24/coffeenote/caramel', },
  { categoryCode: 'recipe-toffeenotes-b2b', icon: '24/coffeenote/caramel', },
  { categoryCode: 'recipe-tropical', icon: '24/coffeenote/tropical', },
  { categoryCode: 'recipe-veryRoasted', icon: '24/coffeenote/roasted', },
  { categoryCode: 'recipe-watermelon', icon: '24/coffeenote/watermelon', },
  { categoryCode: 'recipe-woody', icon: '24/coffeenote/oak-wood', },
];
export default recipes;
